/* jshint esversion: 6 */

const sel = "[data-js-misc-tags]";
const tags = function (el, app) {

    const getByClass = function( cssClass ){
        return $("."+cssClass);
    }

    const $elt = $(el);

    const $showAll = $elt.find( "[data-js-misc-tags-show-all]" );

    const init = function () {
        $(setup);
    };

    const setup = function () {
        $showAll.click( e => {
            e.preventDefault();
            e.stopPropagation();
            $elt.find(".Ge-Hidden").removeClass("Ge-Hidden");
            $showAll.remove();
        });
    }

    return {
        init: init()
    }
};

tags.selector = sel;

export default tags;
